import { useLocation } from 'react-router-dom';
import { useMultiSelectOccupants } from './hooks/useMultiSelectOccupants';
import { Kebab } from '@components/kebab/Kebab';
import { RESERVATIONS_OCCUPANTS_PAGE_PATH } from 'restaurantAdmin/paths';
import { useReservationServiceContext } from './state/ReservationServiceContext';

export const ServicePageKebabMenu = () => {
  const { toggleMultiSelectingOccupants } = useMultiSelectOccupants();
  const { occupants } = useReservationServiceContext();
  const { pathname } = useLocation();

  const onOccupantsPage = pathname.includes(RESERVATIONS_OCCUPANTS_PAGE_PATH);

  return (
    <Kebab
      ariaLabelPrefix="Service"
      options={[
        {
          label: 'Select Multiple Guests',
          onClick: toggleMultiSelectingOccupants,
          disabled: !onOccupantsPage || occupants.length === 0,
        },
      ]}
      side="bottom"
    />
  );
};
